import React, { Component } from 'react';
import { DropTarget, DragSource } from 'react-dnd'
import AddJumpers from './modals/addJumpers'
import CancelJump from './modals/cancelJump'
import RemovableJumper from './modals/removableJumper'
import EditableJumper from './modals/editableJumper'
import AffEditableJumper from './modals/editableAffJump'
import { Card, CardImg, CardText, CardBody, CardTitle, CardHeader, CardFooter, Row, Col, Button, } from 'reactstrap'
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import CreatableJumper from './modals/creatableJumper'
import loadsStore from '../../stores/loads-store';
import ReactDOM from 'react-dom';
import SubmitStudentLog from './modals/submitStudentLog';
import returnLoadSettings from '../helpers/returnLoadSettings';
import AffNestedMenu from '../sub-components/NestedMenus';


// var listStyle = { display: 'inline-block', marginRight: '5px', backgroundColor: '#a0c2df', fontSize: '12px', padding: '3px', borderRadius: '5px', marginBottom: '1px' }

var listStyle = { display: 'inline-block', marginRight: '5px', backgroundColor: 'none !important', fontSize: '12px', padding: '3px', borderRadius: '5px', marginBottom: '1px' }

const Types = {
    ITEM: 'JUMP'
};

const itemSource = {
    beginDrag(props) {
        //console.log('dragging');
        const item = props
        return item
    },
    endDrag(props, monitor, component) {
        //console.log('endrag')
        if (!monitor.didDrop()) {
            return;
        }
        //return props.handleJumperDrop(props)
        return props;
    }
}

function collect(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    }
}


class RenderAffJump extends Component {

    constructor() {
        super();
        this.state = {
            optionMenu: false,
            copyOptionSub: false,
            cutOptionSub: false
        }
    }

    toggleOptions = () => {
        this.setState({
            optionMenu: !this.state.optionMenu
        })
    }

    toggleOptionsBlur = () => {
        this.setState({
            optionMenu: false
        })
    }

    handleDelete = (jumpId) => {
        document.getElementById(jumpId).click();
    }

    componentWillMount() {
        document.addEventListener('click', this.handleClickOutside, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }

    // handleClickOutside = event => {
    //     const domNode = ReactDOM.findDOMNode(this);

    //     if (!domNode || !domNode.contains(event.target)) {
    //         this.setState({
    //             optionMenu: false
    //         });
    //     }
    // }


    handleClickOutside = (event) => {
        const domNode = ReactDOM.findDOMNode(this);
        let id;
        if (document.querySelector('#copy-aff-menu')) {
            id = document.querySelector('#copy-aff-menu')
        } else {
            id = document.querySelector('#move-aff-menu')
        }

        if (!domNode || !domNode.contains(event.target)) {
            if (this.state.optionMenu) {
                if (!id) {
                    this.setState({
                        optionMenu: false
                    });
                }
            }
        }
    }







    handleCopyClick = (affJump = this.props.affJump, loadNum = this.props.loadNum, uid = -1000) => {

        this.setState({
            copyOptionSub: true
        })
        console.log('Copyclicked', affJump, loadNum);
        var payload = {};
        payload = affJump
        if (payload.mainInstructor) {
            payload.mainInstructorId = affJump.mainInstructor["_id"]
        }
        payload.studentId = affJump.student["_id"]
        if (affJump.secondaryInstructor) {
            payload.secondaryInstructorId = affJump.secondaryInstructor["_id"]
        }
        payload.videographerId = affJump.videographer["_id"];
        payload.copy = true;
        loadsStore.copied = true;
        loadsStore.cut = false;
        loadsStore.copyValue = payload;
        // this.props.toggleToster(true, "copied")
        // var element = document.getElementById(uid);
        // element.style.display = "none";
        if (uid !== -1000) {
            var element = document.getElementById(uid);
            element.style.display = "none";
        }

    }
    handleCutClick = (affJump = this.props.affJump, loadNum = this.props.loadNum, jumpId = this.props.jumpId) => {
        this.setState({
            cutOptionSub: true
        })
        var payload = {};
        payload = affJump
        if (payload.mainInstructor) {
            payload.mainInstructorId = affJump.mainInstructor["_id"]
        }
        payload.studentId = affJump.student["_id"]
        if (affJump.secondaryInstructor) {
            payload.secondaryInstructorId = affJump.secondaryInstructor["_id"]
        }
        payload.videographerId = affJump.videographer["_id"];
        loadsStore.cut = true;
        loadsStore.cutValue = { loadNum, jumpId }
        loadsStore.copyValue = payload;


    }

    handleCopyPasteClick = (loadNum) => {
        console.log("working copy paste click", loadNum)
        this.setState({
            optionMenu: !this.state.optionMenu,
            optionSub: false
        })
        var Value = loadsStore.copyValue;
        console.log("pasteclicked", loadNum, Value);
        loadsStore.createAffJump(loadNum, Value).then(d => {
            console.log("Aff in pasted", d);
            if (d) {
                if (loadsStore.cut) {
                    loadsStore.cut = false;
                    const { loadNum, jumpId } = loadsStore.cutValue;
                    loadsStore.cancelAffJump(loadNum, jumpId);
                }
            }
        })


    };




    handleUpdate = (jumpid) => {
        document.getElementById(jumpid).click();
    }

    render() {
        console.log('rendering aff jump on load ' + this.props.loadNum);
        const { affJump, loadNum, jumpId, affInstructorOptions, videographerOptions, affStudentOptions, connectDragSource, isJumperRole, loadsToShow, columnsPerGroup, fontSize } = this.props;
        var IsdisplayOnly = loadsStore.displayOnly ? 'none' : '';

        var affSelfManifestSetting = loadsStore.getAffSelfManifestSetting().value;

        var instructor1Name = "";
        if (affJump.mainInstructor) {
            instructor1Name = affJump.mainInstructor.firstname + " " + affJump.mainInstructor.lastname;
        }

        var instructor2Name = "";
        if (affJump.secondaryInstructor) {
            instructor2Name = affJump.secondaryInstructor.firstname + " " + affJump.secondaryInstructor.lastname;
        }
        var role = localStorage.getItem("role");
        const { settingsMoreThan4 } = returnLoadSettings(loadsToShow, columnsPerGroup, fontSize)


        return connectDragSource(
            <div >
                {/* {
                    this.state.optionSub &&
                    <ul className="menu-option" style={{ zIndex: '100', position: 'absolute', top: '111px', left: '111px' }}>
                        {
                            this.props.loads.map((load, i) => {
                                if (load.loadNum != loadNum) {
                                    return (<li>
                                        <span onClick={() => this.handleCopyPasteClick(load.loadNum)}>{"Load " + load.loadNum}</span>
                                    </li>)
                                }
                            })
                        }
                    </ul>
                } */}
                {
                    this.state.optionMenu &&
                    <ul className="menu-option">
                        {!this.props.isCompleted && <li>
                            <span style={{ color: 'red' }} onClick={() => this.handleDelete("delete-jump" + jumpId)}>Delete</span>
                        </li>}

                        <AffNestedMenu
                            txt={"Copy"}
                            loadNum={this.props.loadNum}
                            loads={loadsStore.getActiveLoadsForDisplay()}
                            handleCopyClick={this.handleCopyClick}
                            handleCopyPasteClick={this.handleCopyPasteClick}
                            id={"copy-aff-menu"}
                        />

                        <AffNestedMenu
                            txt={"Move"}
                            loadNum={this.props.loadNum}
                            loads={loadsStore.getActiveLoadsForDisplay()}
                            handleCopyClick={this.handleCutClick}
                            handleCopyPasteClick={this.handleCopyPasteClick}
                            id={"move-aff-menu"}
                        />


                        {/* <li style={{ position: "relative" }} onMouseLeave={() => { setTimeout(() => { this.setState({ copyOptionSub: false }) }, 1500) }}>
                            <span onClick={() => this.handleCopyClick(affJump, loadNum, -1000)} onMouseOver={() => { setTimeout(() => { this.handleCopyClick(affJump, loadNum, -1000) }, 500) }}>Copy</span>
                            {
                                this.state.copyOptionSub &&
                                <ul className="menu-option" style={{ zIndex: '100', position: 'absolute', top: '0px', right: '167px' }} onMouseLeave={() => { setTimeout(() => { this.setState({ copyOptionSub: false }) }, 1500) }}>
                                    {
                                        this.props.loads.map((load, i) => {
                                            if (load.loadNum != loadNum) {
                                                return (<li>
                                                    <span onClick={() => this.handleCopyPasteClick(load.loadNum)}>{"Load " + load.loadNum}</span>
                                                </li>)
                                            }
                                        })
                                    }
                                </ul>
                            }
                        </li> */}
                        {/* {!this.props.isCompleted && <li style={{ position: "relative" }} onMouseLeave={() => { setTimeout(() => { this.setState({ cutOptionSub: false }) }, 500) }}>
                            <span style={{ color: 'red' }} onClick={() => this.handleCutClick(affJump, loadNum, jumpId)} onMouseOver={() => { setTimeout(() => { this.handleCutClick(affJump, loadNum, jumpId) }, 500) }}>Move</span>
                            {
                                this.state.cutOptionSub &&
                                <ul className="menu-option" style={{ zIndex: '100', position: 'absolute', top: '0px', right: '167px' }} onMouseLeave={() => { setTimeout(() => { this.setState({ cutOptionSub: false }) }, 500) }}>
                                    {
                                        this.props.loads.map((load, i) => {
                                            if (load.loadNum != loadNum) {
                                                return (<li>
                                                    <span onClick={() => this.handleCopyPasteClick(load.loadNum)}>{"Load " + load.loadNum}</span>
                                                </li>)
                                            }
                                        })
                                    }
                                </ul>
                            }
                        </li>} */}


                        {
                            this.props.isCompleted && this.props.affJump.albumUrl &&
                            <li
                                style={{ pointerEvents: 'initial' }}
                                onClick={() => {
                                    var win = window.open(this.props.affJump.albumUrl, '_blank');
                                    win.focus();
                                }}>
                                <span >View Media</span>
                            </li>
                        }


                        <li>
                            <span onClick={() => this.handleUpdate("submit-log" + jumpId)}>View/Submit Log</span>
                        </li>
                        {role == 'video edit' &&
                            <li>
                                <span onClick={() => { navigator.clipboard.writeText(affJump.student.email) }} >email: {affJump.student.email}</span>
                            </li>
                        }
                        {role == 'video edit' &&
                            <li>
                                <span onClick={() => { navigator.clipboard.writeText(affJump.student.phone) }}>phone: {affJump.student.phone}</span>
                            </li>
                        }
                    </ul >
                }

                <SubmitStudentLog isToday={this.props.isToday} loadNum={loadNum} studentId={affJump.student._id} jumpId={jumpId} loadNum={loadNum} jumpType={"affJump"} level={this.props.affJump.studentPackageName}
                    isCompleted={this.props.isCompleted} loadId={this.props.loadId} instructor1Name={instructor1Name} instructor2Name={instructor2Name} />


                <Card className="jumpcard" style={{ pointerEvents: IsdisplayOnly }}>
                    <CancelJump loadNum={loadNum} jumpId={jumpId} jumpType={"affJump"} />

                    {/* <CardHeader className="jumpcardheader align-items-center row">
                        <div className="col-10">
                            <AffEditableJumper type={"aff"} label={"I1"} level={affJump.level} loadNum={loadNum} jumpId={jumpId} jumper={affJump.mainInstructor} options={affInstructorOptions} />
                        </div>
                        <div className="col-2">
                            <CancelJump loadNum={loadNum} jumpId={jumpId} jumpType={"affJump"} />
                        </div>
                    </CardHeader> */}
                    <CardBody className="custom-card-body">


                        {/* <ul className="jumper-load">

                            <li style={listStyle}>
                                <EditableJumper type={"aff"} label={"I1"} loadNum={loadNum} jumpId={jumpId} jumper={affJump.mainInstructor} options={affInstructorOptions} />
                            </li>

                            {affJump.secondaryInstructor ?
                                <li style={listStyle}>
                                    <EditableJumper type={"aff"} label={"I2"} loadNum={loadNum} jumpId={jumpId} jumper={affJump.secondaryInstructor} options={affInstructorOptions} />

                                </li> : null
                            }

                            <li style={listStyle}>
                            	<CreatableJumper type={"aff"} loadNum={loadNum} jumpId={jumpId} jumper={affJump.student} disabled = {true} options={affStudentOptions.map(option => {return {label: option.label, value: option.value._id}})} />
                            </li>

                            {affJump.videographer ?
                                <li style={listStyle}>
                                    <EditableJumper type={"aff"} label={"V"} loadNum={loadNum} jumpId={jumpId} jumper={affJump.videographer} options={videographerOptions} />
                                </li> : null
                            }
                        </ul> */}


                        <div className={"row"}>
                            <div className={settingsMoreThan4 ? "funjumptype custom-col" : "funjumptype col-3"} style={{ backgroundColor: '#D68910' }}>
                                <AffEditableJumper type={"aff"} label={"I1"} level={affJump.level} loadNum={loadNum} jumpId={jumpId} jumper={affJump.mainInstructor} options={affInstructorOptions} affJump={this.props.affJump} />
                            </div>
                            <div className={settingsMoreThan4 ? "cardmiddle jumpers-container" : "cardmiddle col-9"}>
                                {/* <ul className="aff-load">

                                    <li>
                                        <EditableJumper type={"aff"} label={"I1"} loadNum={loadNum} jumpId={jumpId} jumper={affJump.mainInstructor} options={affInstructorOptions} />
                                    </li>

                                    {
                                        affJump.secondaryInstructor ?
                                            <li>
                                                <EditableJumper type={"aff"} label={"I2"} loadNum={loadNum} jumpId={jumpId} jumper={affJump.secondaryInstructor} options={affInstructorOptions} />

                                            </li> : null
                                    }

                                    <li>
                                        <CreatableJumper type={"aff"} loadNum={loadNum} jumpId={jumpId} jumper={affJump.student} disabled={true} options={affStudentOptions.map(option => { return { label: option.label, value: option.value._id } })} />
                                    </li>

                                    {affJump.videographer !== undefined && affJump.videographer.firstname !== "NONE" ?
                                        <li>
                                            <EditableJumper type={"aff"} label={"V"} loadNum={loadNum} jumpId={jumpId} jumper={affJump.videographer} options={videographerOptions} />
                                        </li> : null
                                    }
                                </ul> */}

                                <ul className="aff-load" >
                                    {
                                        affJump.mainInstructor ?
                                            <li>
                                                <EditableJumper type={"aff"} label={"I1"}
                                                    isToday={this.props.isToday}
                                                    loadNum={loadNum}
                                                    jumpId={jumpId}
                                                    affJump={this.props.affJump}
                                                    jumper={affJump.mainInstructor}
                                                    student={affJump.student._id} level={affJump.level}
                                                    isCompleted={this.props.isCompleted}
                                                    loadId={this.props.loadId}
                                                    activeJumperIdsOnLoad={this.props.load.activeJumperIds}
                                                    columnsPerGroup={this.props.columnsPerGroup}
                                                />
                                            </li>
                                            :
                                            null
                                    }

                                    {/* </ul> */}
                                    <li>
                                        <CreatableJumper
                                            isToday={this.props.isToday}
                                            type={"aff"}
                                            loadNum={loadNum}
                                            jumpId={jumpId}
                                            jumper={affJump.student}
                                            level={affJump.level}
                                            isCompleted={this.props.isCompleted}
                                            loadId={this.props.loadId}
                                            affJump={this.props.affJump}
                                            activeJumperIdsOnLoad={this.props.load.activeJumperIds}
                                            disabled={affSelfManifestSetting === "yes" ? false : true}
                                            elementWidth={{ width: '170px' }}
                                        />
                                    </li>
                                    {
                                        affJump.secondaryInstructor ?
                                            // <ul className="aff-load">
                                            <li>
                                                <EditableJumper type={"aff"}
                                                    activeJumperIdsOnLoad={this.props.load.activeJumperIds}
                                                    isToday={this.props.isToday}
                                                    label={"I2"} loadNum={loadNum}
                                                    jumpId={jumpId}
                                                    affJump={this.props.affJump}
                                                    jumper={affJump.secondaryInstructor}
                                                    student={affJump.student._id}
                                                    level={affJump.level}
                                                    isCompleted={this.props.isCompleted}
                                                    loadId={this.props.loadId}
                                                    elementWidth={{ width: '170px' }}

                                                />
                                            </li>
                                            // </ul>
                                            : null
                                    }

                                    {/* <ul className="aff-load"> */}
                                    {/* </ul> */}
                                    {/* <ul className="aff-load"> */}

                                    {affJump.videographer && (!loadsStore.displayOnly || (loadsStore.displayOnly && affJump.videographer.firstname !== "NONE")) ?
                                        <li>
                                            <EditableJumper
                                                activeJumperIdsOnLoad={this.props.load.activeJumperIds}
                                                isToday={this.props.isToday}
                                                type={"aff"}
                                                label={"V"}
                                                loadNum={loadNum}
                                                jumpId={jumpId}
                                                affJump={this.props.affJump}
                                                level={affJump.level}
                                                student={affJump.student._id}
                                                jumper={affJump.videographer}
                                                loadId={this.props.loadId}
                                                isCompleted={this.props.isCompleted}
                                                elementWidth={!affJump.secondaryInstructor ? { width: '170px' } : { width: '170px', position: "absolute", left: "59%" }}
                                            />
                                        </li> : null
                                    }
                                </ul>

                                {loadsStore.displayOnly ? null :
                                    <div className="aff right-menu" style={{ pointerEvents: 'initial' }} onClick={this.toggleOptions} onBlur={this.toggleOptionsBlur}>
                                        <span>
                                            <i className="fa fa-ellipsis-v"></i>
                                        </span>
                                    </div>
                                }
                            </div>

                            {/* <Col xs="12" md="2" lg="1" className="jumpClose">
                                <CancelJump loadNum={loadNum} jumpId={jumpId} jumpType={"affJump"} />
                            </Col> */}
                        </div>
                    </CardBody>
                    {affJump.note && window.ENV.tenant ==="montereybay"?
                        <CardFooter className="fun-card-footer" >{affJump.note}</CardFooter> : null}
                </Card>
            </div >
        )
    }
}


export default DragSource(Types.ITEM, itemSource, collect)(RenderAffJump)
